export default {
  root: {
    width: '25rem'
  },
  icon: {
    size: '1.25rem'
  },
  content: {
    padding: '0.75rem'
  },
  summary: {
    font: {
      size: '1.25rem'
    }
  },
  detail: {
    font: {
      size: '1rem'
    }
  },
  close: {
    icon: {
      size: '1.25rem'
    }
  }
};